import { WriteTimeoutError } from './firestoreErrors'

// Firestore (full SDK) buffers writes while offline and only settles the
// returned promise once the backend acknowledges. Without a bound, a write
// attempted while unreachable leaves the mutation pending forever — no success,
// no error, no UI feedback. This caps how long we wait before surfacing a
// connection error. The underlying write stays queued in the Firestore client
// and still syncs if connectivity returns within the session.
export const WRITE_TIMEOUT_MS = 10_000

export const withWriteTimeout = <T>(
  operation: Promise<T>,
  timeoutMs: number = WRITE_TIMEOUT_MS
): Promise<T> => {
  let timer: ReturnType<typeof setTimeout>

  const timeout = new Promise<never>((_, reject) => {
    timer = setTimeout(() => reject(new WriteTimeoutError()), timeoutMs)
  })

  return Promise.race([operation, timeout]).finally(() => clearTimeout(timer))
}
